import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

import {createElement, PropTypes} from 'rlink-react';
import LegacyScrollTransition from 'rlink-transitions/LegacyScrollTransition';

export default function EliteDescriptionPanelSpaceMarines ({css}) {
  return (
    <LegacyScrollTransition css={css}>
      <div className={css.column}>
        <h1>
          <FormattedHTMLMessage
            id="ui.branding.heading.DOW3_GABRIEL_ANGELOS_DESCRIPTION_PANEL_ANIMATED_TAGLINE"
            defaultMessage={'<span class="{FIRST_CLASSNAME}">Gabriel</span> <span class="{SECOND_CLASSNAME}">Angelos</span>'}
            description="Animated tagline appearing on the Space Marines faction page. The two different <span>...</span> parts fade-in one after the other and should be of roughly equal size. {FIRST_CLASSNAME} and {SECOND_CLASSNAME} are used to give the different parts their animations and should remain in order."
            values={{
              FIRST_CLASSNAME: css.first,
              SECOND_CLASSNAME: css.second,
            }} />
        </h1>
        <hr style={{marginLeft: 0}} className={css.short} />
        <p>
          <FormattedMessage
            id="ui.branding.copy.DOW3_GABRIEL_ANGELOS_DESCRIPTION_PANEL_BODY"
            defaultMessage="Gabriel Angelos, Master of the Blood Ravens chapter of Space Marines, guides his brothers against the most dangerous enemies in the Galaxy. Uncompromising and honorable, Gabriel has little patience for those who would hesitate in battle."
            description="Paragraph description of the Space Marines hero. Gabriel Angelos is a character. Blood Ravens is a subdivision of the Space Marines. Space Marines is a faction." />
        </p>
      </div>
    </LegacyScrollTransition>
  );
}

EliteDescriptionPanelSpaceMarines.propTypes = {
  css: PropTypes.object,
};



// WEBPACK FOOTER //
// ./apps/www.dawnofwar.com/src/components/EliteDescriptionPanelSpaceMarines.jsx